export default __webpack_public_path__ + "static/media/img6.31e37017.jpg";